<template>
  <div class="down-wrapper">
    <div class="down-wrapper-inside">
      <img :src="getLogoUrl()" :alt="$t('company_shortname')" class="logo" />

      <p>
        {{ $t("service_down_apology") }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceDown",
  computed: {
    serviceDown() {
      return this.$store.state.onboarding.serviceDown;
    }
  },
  mounted() {
    this.$store.dispatch("onboarding/testServiceDown").then(() => {
      this.processServiceDown();
    });
  },
  methods: {
    processServiceDown() {
      if (!this.serviceDown) {
        this.$router.push({ name: "home" });
      }
    }
  }
};
</script>

<style lang="scss">
header {
  display: none;
}
</style>

<style lang="scss" scoped>
.down-wrapper {
  width: 100vw;
  height: 100vh;
  position: absolute;
  z-index: 1000000;
  top: 0;
  left: 0;
  background: #fff;
  color: #000;

  &-inside {
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    position: absolute;
    max-width: 350px;
    text-align: center;

    .logo {
      width: 80%;
      margin-bottom: 50px;
    }

    p {
      width: 100%;
      display: block;
      font-size: 20px;
    }
  }
}
</style>
